import axios from './config';

export const getDistributors = ({ queryStr}) => {
  return axios.get(`/contacts-distributors?${queryStr}`).then(res => res.data.data);
};
